import * as React from "react";

function SvgDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20.97 24"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M20.52 13.99a1.53 1.53 0 000-2.17 1.63 1.63 0 00-2.25 0l-6.21 6.17V1.58a1.59 1.59 0 00-1.58-1.59 1.54 1.54 0 00-1.57 1.59v16.41l-6.22-6.21a1.62 1.62 0 00-2.24 0 1.52 1.52 0 00-.46 1.12 1.66 1.66 0 00.46 1.09l10 10z" />
    </svg>
  );
}

const MemoSvgDown = React.memo(SvgDown);
export default MemoSvgDown;
